import { usePaging } from 'hooks/usePaging';
import { useGetCustomerGroupsQuery } from 'services/customer-groups';
import { FindAllCustomerGroupDto } from 'types';
import { DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function useCustomerGroupsPaging(params: Omit<FindAllCustomerGroupDto, 'pageIndex' | 'pageSize'>) {
  const { keyword } = params;
  const { pageIndex, changePage, resetPage } = usePaging(params);
  const {
    data: customerGroupsResponse,
    error,
    isLoading,
    isFetching
  } = useGetCustomerGroupsQuery(
    {
      pageIndex: pageIndex,
      pageSize,
      keyword
    },
    {
      refetchOnMountOrArgChange: true
    }
  );
  const handleChangePage = changePage;

  return {
    customerGroups: customerGroupsResponse?.data.rows,
    count: customerGroupsResponse ? customerGroupsResponse.data.count : 0,
    pageIndex,
    isLoading: isFetching || isLoading,
    error,
    handleChangePage,
    resetPage
  };
}
